import { useState } from 'react';

import VyseIcon from '../../../../assets/icons/Vyse';
import IntegrationCard from '../../../../shared/components/IntegrationCard/IntegrationCard';
import useVoiceCallIntegration from '../../hooks/useVoiceCallAgentIntegration';
import { VoiceCallAgentType } from '../../interfaces';
import VyseIntegrationDialog from '../VyseIntegrationDialog/VyseIntegrationDialog';

const VyseIntegration = () => {
  const { loading, integrations, error } = useVoiceCallIntegration();
  const [showConfigurationDialog, setShowConfigurationDialog] = useState(false);

  return (
    <>
      <IntegrationCard
        icon={VyseIcon as any}
        isIntegrated={integrations.has(VoiceCallAgentType.VYSE)}
        description='Effortlessly engage with your leads through the Vyse Call Agent for smarter conversations.'
        loading={loading}
        name='Vyse'
        onConfigure={setShowConfigurationDialog.bind(null, true)}
        onIntegrate={setShowConfigurationDialog.bind(null, true)}
        error={error}
      />
      {showConfigurationDialog && (
        <VyseIntegrationDialog
          onClose={setShowConfigurationDialog.bind(null, false)}
        />
      )}
    </>
  );
};
export default VyseIntegration;
